import { ability } from "@/utils/casl/abilityFunctional.ts";

export const canAccess = (abilityMeta: any) => {
  if (!abilityMeta) return false;

  const actions = Array.isArray(abilityMeta.action)
    ? abilityMeta.action
    : [abilityMeta.action];

  const subjects = Array.isArray(abilityMeta.subject)
    ? abilityMeta.subject
    : [abilityMeta.subject];

  return actions.some((action: any) =>
    subjects.some((subject: any) => ability.can(action, subject)),
  );
};
